import type React from 'react';
import { useEffect, useState } from 'react';
import { useDepartments } from '@/common/useDepartments';

export const UTCOffsets: React.FC = () => {
  const { selectedDepartment } = useDepartments();

  const [utcOffset, setUtcOffset] = useState('');

  useEffect(() => {
    const now = new Date();

    const offsetInMinutes = now.getTimezoneOffset();
    const offsetHours = -(offsetInMinutes / 60);
    const formattedOffset = `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;

    setUtcOffset(formattedOffset);
  }, []);

  return (
    <div style={{ color: 'white', marginLeft: 'auto' }}>
      You: {utcOffset} | Dept: UTC{selectedDepartment?.timeZone || 0}
    </div>
  );
};
